import ProcessMiddle from "./ProcessMiddle";

import './Efficiency.scss'
import { useSelector } from "react-redux";

export default function Efficiency({ title, marginBottom = '0px' }: { title?: string; marginBottom?: string }) {
  const MomentumStore = useSelector((state: any) => state?.MomentumStore)
  const Perfomance5d = MomentumStore?.OverviewMomentum?.stockPerfomance5d || 0
  const Perfomance1m = MomentumStore?.OverviewMomentum?.stockPerfomance1m || 0
  const PerfomanceFromReport = MomentumStore?.OverviewMomentum?.stockPerfomanceFromReport || 0
  const Perfomance6m = MomentumStore?.OverviewMomentum?.stockPerfomance6m || 0
  const Perfomance1y = MomentumStore?.OverviewMomentum?.stockPerfomance1y || 0

  const dataHs = [
    { valueShow: Perfomance5d.toFixed(2), value: Perfomance5d, title: '5 ngày' },
    { valueShow: Perfomance1m.toFixed(2), value: Perfomance1m, title: '1 tháng' },
    { valueShow: PerfomanceFromReport.toFixed(2), value: PerfomanceFromReport, title: 'Từ thời điểm ra báo cáo' },
    { valueShow: Perfomance6m.toFixed(2), value: Perfomance6m, title: '6 tháng' },
    { valueShow: Perfomance1y.toFixed(2), value: Perfomance1y, title: '1 năm' },
  ]

  return (
    <>
      <div className="DyTDAhZGhH">
        {title ? <div className="Cnwuupimny">{title}</div> : null}
        <div className="DZqAyWJgNy">
          {
            dataHs.map((item, key) => {
              return (
                <div className="EkeUhhunmo" style={{ marginBottom: marginBottom }} key={key}>
                  <div className="qPAmgtbYXx">{item.title}</div>
                  <div className="ruodZjPUDN">
                    <ProcessMiddle height={'15px'} valueShow={item?.valueShow} value={item?.value} />
                  </div>
                </div>
              )
            })
          }

        </div>
      </div>
    </>
  )
}
